import {
  Button,
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from '@e2n/ui';
import { useTerminDeleteHandler } from '@/domain/termine/hooks/useTerminDeleteHandler';
import { Termin } from '@/domain/termine/shared/types';
import { useTranslation } from 'react-i18next';

type TerminDeleteDrawerProps = {
  termin: Termin;
  open: boolean;
  onClose: (deleted: boolean) => void;
};

export function TerminDeleteDrawer({
  termin,
  open,
  onClose,
}: TerminDeleteDrawerProps) {
  const { t } = useTranslation();
  const { handleDelete, loading } = useTerminDeleteHandler(termin);

  const handleConfirmDelete = async () => {
    const deleted = await handleDelete();
    onClose(deleted);
  };

  return (
    <Drawer
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose(false);
      }}>
      <DrawerContent>
        <DrawerHeader className="text-left">
          <DrawerTitle className="pb-3">
            {t('domain.termine.deleteDialog.deleteTermin')}
          </DrawerTitle>
          <DrawerDescription>
            {t('domain.termine.deleteDialog.deleteTerminDescription')}
          </DrawerDescription>
        </DrawerHeader>
        <DrawerFooter className="flex justify-end gap-4">
          <Button
            variant="destructive"
            disabled={loading}
            onClick={handleConfirmDelete}>
            {t('domain.termine.deleteDialog.delete')}
          </Button>
          <Button variant="outline" onClick={() => onClose(false)}>
            {t('domain.termine.deleteDialog.cancel')}
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}
